import React, { useState } from "react";
import "./signup.scss";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAuth,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  updateProfile,
  sendEmailVerification,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { collection, addDoc, setDoc, doc } from "firebase/firestore";
import { auth, firestoredb } from "../../../config";

const Signup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fName, setFName] = useState("")
  const [lName, setLName] = useState("")


  const handleRegisterUser = async () => {
    const valid = Validation();
    console.log(valid);
    if (valid.email || valid.password) {
      valid.email ? toast.error("Invalid Email")
        : toast.error("Invalid Password")
    } else {
      try {
        await createUserWithEmailAndPassword(auth, email, password)
          .then(async (res) => {
            const { user } = res;
            updateProfile(auth.currentUser, {
              displayName: fName + " " + lName,
            })
              .then(async () => {
                await setDoc(doc(firestoredb, "users", user.uid), {
                  uid: user.uid,
                  firstName: fName,
                  lastName: lName,
                  fullName: fName + " " + lName,
                  userEmail: email,

                })
                  .then((res1) => {
                    // const userData = {
                    //   email: user.email,
                    //   name: user.displayName,
                    //   uid: user.uid,

                    // };
                    // const jsonString = JSON.stringify(userData);
                    // localStorage.setItem("resumebuilderuser", jsonString);
                    toast("Signup success", { toastId: "userloggedin" });
                    // sendEmailVerification(auth.currentUser)
                    //   .then((res) => {
                    //     console.log(res);
                    //   })
                    //   .catch((err) => {
                    //     console.log(err);
                    //   });

                    signOut(auth)
                      .then(() => {
                        console.log("User signed out successfully.");
                        navigate("/login");
                      })
                      .catch((error) => {
                        console.log("Error signing out:", error);
                      });
                  })
                  .catch((error) => {
                    console.log(error);
                    return false;
                  });
              })
              .catch((error) => {
                console.log(error);
                return false;
              });
          })
          .catch((error) => {
            console.log(error);
            if (
              error ==
              "FirebaseError: Firebase: Error (auth/email-already-in-use)."
            ) {
              toast("This email is already Registered", {
                toastId: "alreadyRegistered",
              });
            }
            return false;
          });
      } catch (err) {
        console.error(err);
        alert(err.message);
        return false;
      }
      return "";
    }
  };

  const Validation = () => {
    let errorobj = {
      email: false,
      password: false,
    };

    if (email == "") {
      errorobj["email"] = true;
    }
    if (email.length > 40) {
      errorobj["email"] = true;
    }
    if (password.length < 8) {
      errorobj["password"] = true;
    }
    if (password.length > 62) {
      errorobj["password"] = true;
    }

    // setErrorObj(errorobj);
    return errorobj;
  };

  return (
    <div>
      <div className="signup">
        <div className="top">
          {/* <Icon icon="ri:openai-fill" width="40" height="40" /> */}
          <h1>MADIS</h1>
        </div>
        <div className="middle">
          <h3>Create your account</h3>
          <p>
            Note that phone verification may be required for signup. Your number
            will only be used to verify your identity for security purposes.
          </p>
          <input type="text" name="" placeholder="First Name" value={fName} onChange={(e) => setFName(e.target.value)} />
          <input type="text" name="" placeholder="Last Name" value={lName} onChange={(e) => setLName(e.target.value)} />
          <input type="email" name="" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="password" name="" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <div className="continue-btn">
            <button onClick={handleRegisterUser}>Continue</button>
          </div>
          <div className="sign-up">
            <p>
              Already have an account?
              <Link to="/login">
                <span>Log in</span>
              </Link>
            </p>
          </div>
          <div className="or">
            <div className="left"></div>
            <p>OR</p>
            <div className="right"></div>
          </div>
          <div className="three-btn">
            <button>
              <Icon
                icon="flat-color-icons:google"
                color="white"
                width="30"
                height="30"
              />
              Continue with Google
            </button>
            {/* <button>
              <Icon
                icon="logos:microsoft-icon"
                color="white"
                width="30"
                height="30"
              />
              Continue with Microsoft Account
            </button>
            <button>
              <Icon icon="devicon:apple" color="white" width="30" height="30" />
              Continue with Apple
            </button> */}
          </div>
        </div>
        <div className="bottom">
          <p>Terms of use</p>
          <p>Privacy policy</p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
